/* eslint-disable no-unused-vars */
import React, {useEffect, useState} from 'react';
import FilterWithGroupWithoutSelectedOptions from './FilterWithGroupWithoutSelectedOptions';

const FilterOfFilters = ({placeholder, classButton, tabIndex, options, addOption, mode}) => {
  return (
    <>
      <FilterWithGroupWithoutSelectedOptions
        index={tabIndex}
        classButton={classButton}
        title={placeholder}
        options={options}
        apply={addOption}
      />
    </>
  );
};

export default FilterOfFilters;
